import { render, staticRenderFns } from "./AccountSettingEmailAddress.vue?vue&type=template&id=0c1c105d&scoped=true&"
import script from "./AccountSettingEmailAddress.vue?vue&type=script&lang=js&"
export * from "./AccountSettingEmailAddress.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingEmailAddress.vue?vue&type=style&index=0&id=0c1c105d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1c105d",
  null
  
)

export default component.exports